/* Progressive family-card previews. Original product/variant links remain functional without JS.
   No cart requests, inventory changes, background tracking or third-party dependencies. */
(() => {
  if (window.__hameldownBrandShopBound) return;
  window.__hameldownBrandShopBound = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const choice = event.target.closest('[data-hbs-choice]');
    if (!choice || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = choice.closest('[data-hbs-family]');
    if (!card || !choice.getAttribute('href')) return;
    event.preventDefault();
    card.querySelectorAll('[data-hbs-choice]').forEach((el) => {
      if (el === choice) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
    card.querySelectorAll('[data-hbs-product-link]').forEach((el) => el.setAttribute('href', choice.getAttribute('href')));
    const image = card.querySelector('[data-hbs-product-image]');
    if (image && choice.dataset.image) {
      image.removeAttribute('srcset');
      image.src = choice.dataset.image;
      image.alt = choice.dataset.imageAlt || choice.dataset.label || '';
    }
    const price = card.querySelector('[data-hbs-price]');
    if (price) price.textContent = choice.dataset.price || '';
    const options = card.querySelector('[data-hbs-options]');
    if (options) options.textContent = choice.dataset.options || '';
    const label = card.querySelector('[data-hbs-label]');
    if (label) label.textContent = choice.dataset.label + (choice.dataset.available === 'false' ? ' - sold out' : '');
  });
})();
